// 오류 한 줄 — errors.describeSimpleError 의 결과를 담는 자리. props: { children, style }
import React from 'react';
import { T, FONT } from '../../theme';

var base = { padding: '12px 14px', color: T.danger, fontSize: FONT.body, textAlign: 'center' };

function ErrorText(props) {
  if (!props.children) return null;
  return <div className="ss-error" role="alert" style={props.style ? Object.assign({}, base, props.style) : base}>{props.children}</div>;
}

export default ErrorText;
